import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";

const OutOfPlace = () => {
    const { analysis } = useSelector((state) => state.tc);
    const { isAuth, user } = useSelector((state) => state.user);

    const [outOfPlace, setRedFlags] = useState([]);

    useEffect(() => {
        if (isAuth && user && user.preferences) {
          const textSize = user.preferences.textSize;
    
          switch (textSize) {
            case 0: // Small
                document.documentElement.style.setProperty('--analysis-font-size-header', '0.8vw');
                document.documentElement.style.setProperty('--analysis-font-size-label', '10px');
                document.documentElement.style.setProperty('--analysis-font-size-button', '0.8vw');
                break;
            case 1: // Medium (default)
                document.documentElement.style.setProperty('--analysis-font-size-header', '1vw');
                document.documentElement.style.setProperty('--analysis-font-size-label', '12px');
                document.documentElement.style.setProperty('--analysis-font-size-button', '1vw');
                break;
            case 2: // Large
                document.documentElement.style.setProperty('--analysis-font-size-header', '1.3vw');
                document.documentElement.style.setProperty('--analysis-font-size-label', '16px');
                document.documentElement.style.setProperty('--analysis-font-size-button', '1.5vw');
                break;
            default:
              break;
          }
        } else if (!isAuth) { 
            document.documentElement.style.setProperty('--analysis-font-size-header', '1vw');
            document.documentElement.style.setProperty('--analysis-font-size-label', '12px');
            document.documentElement.style.setProperty('--analysis-font-size-button', '1vw');
          }
        }, [user, isAuth]);

    useEffect(() => {
        if (analysis){
            setRedFlags(analysis.outofplace);
        }
    }, [analysis]);

    const handleClick = (ref) => {
        if (ref) {
            ref.scrollIntoView({ behavior: 'smooth' });
        }
    }

    return (
        <div className="outOfPlaceResults">
            <p className="resultsExplanation">Out of place lines are lines that are not typically present in the type of contract you have submitted.</p>
            <div key="showResults" className={"outOfPlaceList"}>
                {outOfPlace.map( (element, index) => {
                    return (<li key={index} className={"outOfPlaceOutput resultsList"}
                        ref={(e) => {element.oref = e}}
                        onClick={()=>handleClick(element.ref)}>{element.content}
                        <ul>{element.reason}</ul>
                        </li>
                )})}
            </div>
        </div>
    );
}

export default OutOfPlace;